/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Why_Private_DescInputs */

const en_wc_why_private_desc = /** @type {(inputs: Wc_Why_Private_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spelling, grammar and everything else work offline. No account, no subscription, no upload.`)
};

/**
* | output |
* | --- |
* | "Spelling, grammar and everything else work offline. No account, no subscription, no upload." |
*
* @param {Wc_Why_Private_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_why_private_desc = /** @type {((inputs?: Wc_Why_Private_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Why_Private_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_why_private_desc(inputs)
});
export { wc_why_private_desc as "wc.why.private.desc" }